import {PlateRecognitionActionTypes} from '../../constants/actionType';

const initialState = {
  isPlateRecognitionEnabled: false,
  isAlreadyScannedAllEmptyNests: false,
  isAllPlatesScanned: false,
  isPlateAlreadyTrained: false,
  isPlateEditStateChanged: false,
  isIncompatibleVisionVersion: false,
};

export default function plateRecognitionStateReducer(state = initialState, action = '') {
  switch (action.type) {
    case PlateRecognitionActionTypes.SET_IS_PLATE_RECOGNITION_ENABLED:
      return {...state, isPlateRecognitionEnabled: action.isPlateRecognitionEnabled};
    case PlateRecognitionActionTypes.SET_IS_ALREADY_SCANNED_ALL_EMPTY_NESTS:
      return {...state, isAlreadyScannedAllEmptyNests: action.isAlreadyScannedAllEmptyNests};
    case PlateRecognitionActionTypes.SET_IS_ALL_PLATES_SCANNED:
      return {...state, isAllPlatesScanned: action.isAllPlatesScanned};
    case PlateRecognitionActionTypes.SET_IS_ALL_PLATE_ALREADY_TRAINED:
      return {...state, isPlateAlreadyTrained: action.isPlateAlreadyTrained};
    case PlateRecognitionActionTypes.SET_IS_PLATE_EDIT_STATE_CHANGED:
      return {...state, isPlateEditStateChanged: action.isPlateEditStateChanged};
    case PlateRecognitionActionTypes.SET_IS_INCOMPATIBLE_VISION_VERSION:
      return {...state, isPlateEditStateChanged: action.isIncompatibleVisionVersion};
    case PlateRecognitionActionTypes.RESTORE_PLATE_RECOGNITION_STATE:
      return action.state;
    default:
      return state;
  }
}
